import {
	Breadcrumbs,
	Panel,
	PanelBody,
	PanelHeader
} from "@itandi/itandi-bb-ui";
import Link from "next/link";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { PATH as STAFFS_PATH } from "~/pages/settings/staffs";
import SettingStyles from "../../../SettingStyle.module.scss";
import { FormInputPage } from "../FormInputPage";

export function Page() {
	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{ as: Link, href: STAFFS_PATH, label: "担当者一覧" },
							{ label: "担当者追加" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader title="担当者追加" />
					<PanelBody>
						<FormInputPage />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
